var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChecklistDefaultIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.11944 2.07002C7.68419 1.84108 8.31581 1.84108 8.88056 2.07002L13.5672 3.97C13.9799 4.13733 14.25 4.53824 14.25 4.98363V11.0166C14.25 11.4619 13.9799 11.8629 13.5672 12.0302L8.88056 13.9302C8.31581 14.1591 7.68419 14.1591 7.11944 13.9302L2.43282 12.0302C2.02007 11.8629 1.75 11.4619 1.75 11.0166V4.98363C1.75 4.53824 2.02007 4.13733 2.43282 3.97L7.11944 2.07002ZM8.52831 2.93884C8.1895 2.80147 7.8105 2.80147 7.47169 2.93884L6.27561 3.42372L10.9799 5.25316L12.6481 4.60903L8.52831 2.93884ZM9.68194 5.75431L5.0092 3.93713L3.36893 4.60211L8.00081 6.40341L9.68194 5.75431ZM2.6875 11.0166C2.6875 11.0802 2.72608 11.1374 2.78504 11.1614L7.47169 13.0614C7.49144 13.0694 7.51144 13.0769 7.53144 13.084V7.22675L2.6875 5.34301V11.0166ZM8.52831 13.0614L13.2149 11.1614C13.2739 11.1374 13.3125 11.0802 13.3125 11.0166V5.35746L8.46894 7.22763V13.0839C8.48888 13.0768 8.50869 13.0693 8.52831 13.0614Z",
    fill: "#110024"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklistDefaultIcon);
export default __webpack_public_path__ + "static/media/checklist-default-icon.af4cbcb3fb7dc927b1ad38635b4a2a60.svg";
export { ForwardRef as ReactComponent };